/* P r o d u c t  T a b s */
function slideDown(el, duration = 300) {
    if (el.dataset.animating === '1') return;
    el.dataset.animating = '1';

    el.style.display = 'block';
    const target = el.scrollHeight;

    el.style.height = '0px';
    el.offsetHeight;

    el.style.transition = `height ${duration}ms ease`;
    el.style.height = target + 'px';

    function onEnd(e) {
      if (e.propertyName !== 'height') return;
      el.removeEventListener('transitionend', onEnd);

      el.style.transition = '';
      el.style.height = 'auto';
      el.dataset.animating = '0';
    }
    el.addEventListener('transitionend', onEnd);
}

function slideUp(el, duration = 300) {
    if (el.dataset.animating === '1') return;
    el.dataset.animating = '1';

    el.style.height = el.scrollHeight + 'px';
    el.style.transition = `height ${duration}ms ease`;

    el.offsetHeight;

    el.style.height = '0px';

    function onEnd(e) {
      if (e.propertyName !== 'height') return;
      el.removeEventListener('transitionend', onEnd);
      el.style.transition = '';

      el.dataset.animating = '0';
    }
    el.addEventListener('transitionend', onEnd);
}

function slideToggle(el, duration = 300) {
    const isClosed = getComputedStyle(el).height === '0px';
    if (isClosed || el.style.height === '' && !el.classList.contains('is-open')) {
      slideDown(el, duration);
    } else {
      if (getComputedStyle(el).height === 'auto') {
        el.style.height = el.scrollHeight + 'px';
        el.offsetHeight;
      }
      slideUp(el, duration);
    }
  }

const blocks = document.querySelectorAll('.product__tabs');
blocks.forEach((block, i) => {
    const title = block.querySelector('.product__tabs-title');
    const panel = block.querySelector('.product__tabs-content');

    if (!title || !panel) return;

    title.setAttribute('role', 'button');
    title.setAttribute('tabindex', '0');
    const panelId = panel.id || `product-tab-panel-${i}`;
    panel.id = panelId;
    title.setAttribute('aria-controls', panelId);
    title.setAttribute('aria-expanded', 'false');

    panel.style.height = '0px';
    panel.dataset.animating = '0';

    function toggle() {
      const isOpen = title.classList.contains('is-open');
      if (isOpen) {
        title.classList.remove('is-open');
        title.setAttribute('aria-expanded', 'false');
        slideUp(panel, 300);
      } else {
        title.classList.add('is-open');
        title.setAttribute('aria-expanded', 'true');
        slideDown(panel, 300);
      }
    }

    title.addEventListener('click', toggle);
    title.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggle();
      }
    });
});
/* END P r o d u c t  T a b s */

/* P r o d u c t  S w a t c h */
document.addEventListener("DOMContentLoaded", () => {
  // Encuentra todos los contenedores de swatches
  const swatchContainers = document.querySelectorAll(".color-swatch-block__container");

  swatchContainers.forEach(container => {
    // Encuentra el producto relacionado
    const productCard = container.closest(".product-card");
    const mainImage = productCard.querySelector(".product-card__image--primary");

    // Verifica que la imagen principal existe y guarda su estado original
    if (mainImage) {
      mainImage.dataset.originalSrc = mainImage.src;
      mainImage.dataset.originalSrcset = mainImage.srcset;
    }

    // Agrega eventos de hover a cada swatch
    container.querySelectorAll(".color-swatch-block__block").forEach(swatch => {
      const newImageUrl = swatch.dataset.image;

      swatch.addEventListener("mouseenter", () => {
        if (newImageUrl && mainImage) {
          // Actualizar el src de la imagen principal
          mainImage.src = newImageUrl;

          // Si `srcset` está en uso, actualízalo también para dispositivos con diferentes resoluciones
          mainImage.srcset = `${newImageUrl}?width=200 200w, ${newImageUrl}?width=300 300w, ${newImageUrl}?width=400 400w, ${newImageUrl}?width=500 500w, ${newImageUrl}?width=600 600w, ${newImageUrl}?width=700 700w, ${newImageUrl}?width=800 800w, ${newImageUrl}?width=1000 1000w`;

          console.log("Image updated to:", newImageUrl);
        }
      });

      swatch.addEventListener("mouseleave", () => {
        if (mainImage) {
          // Restaura la imagen original
          mainImage.src = mainImage.dataset.originalSrc;
          mainImage.srcset = mainImage.dataset.originalSrcset;

          console.log("Image restored to original:", mainImage.dataset.originalSrc);
        }
      });
    });
  });
});
/* END P r o d u c t  S w a t c h */

/* M e n ú */
document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector(".shopify-section-header");
  const submenus = document.querySelectorAll(".list-menu-item.list-menu--submenu");
  if (document.body.classList.contains('template-index')) {
    document.querySelectorAll('.shopify-section.shopify-section-header')
      .forEach(function(section) {
        section.classList.add('transparent-white');
      });
  }else{
    document.querySelectorAll('.shopify-section.shopify-section-header')
      .forEach(function(section) {
        section.classList.add('transparent-black');
      });
  }

  submenus.forEach(item => {
    item.addEventListener("mouseenter", () => {
      header.classList.add("force-solid");
    });
    item.addEventListener("mouseleave", () => {
      header.classList.remove("force-solid");
    });
  });
});